import React from 'react';
import { TIMELINES, type TaskTimeline } from '../constants/taskCreation';

interface Props {
  selected: TaskTimeline;
  customDeadline: string;
  onSelect: (id: TaskTimeline) => void;
  onDeadlineChange: (date: string) => void;
}

const TimelinePicker: React.FC<Props> = ({ selected, customDeadline, onSelect, onDeadlineChange }) => {
  return (
    <div className="space-y-3">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">
        {TIMELINES.map((t) => {
          const isActive = selected === t.id;
          return (
            <button
              key={t.id}
              type="button"
              onClick={() => onSelect(t.id)}
              className={`flex flex-col items-center gap-1.5 p-3 rounded-xl border-2 transition-all duration-200 outline-none focus-visible:ring-2 focus-visible:ring-tech-cyan ${
                isActive
                  ? 'border-tech-cyan bg-tech-cyan/10 shadow-tech-glow'
                  : 'border-tech-border/50 bg-tech-gray/40 hover:border-tech-cyan/30 hover:bg-tech-gray/60'
              }`}
            >
              <span className="text-2xl">{t.emoji}</span>
              <span className={`text-xs font-bold ${isActive ? 'text-tech-cyan' : 'text-tech-text'}`}>
                {t.label}
              </span>
              <span className="text-[10px] text-tech-text-muted">{t.desc}</span>
            </button>
          );
        })}
      </div>
      {selected === 'custom' && (
        <div className="animate-slide-up">
          <input
            type="date"
            value={customDeadline}
            onChange={e => onDeadlineChange(e.target.value)}
            className="w-full sm:w-64 px-4 py-2.5 rounded-xl bg-tech-gray border border-tech-cyan/30 text-tech-text text-sm focus:outline-none focus:ring-2 focus:ring-tech-cyan/40 focus:border-tech-cyan transition-all"
          />
        </div>
      )}
    </div>
  );
};

export default TimelinePicker;
